import React from "react";
import * as Constants from '../Global/constants';
import { getLocalStorageVariables, getThemeSettingsVariables, handleTokenExpiry, isEmptyArray, isEmptyVariable, isJsonString, removeHtmlTags } from "../Global/commonFunctions";
import * as TemplateConstants from "../Global/templateConstants";
import { AddNewButtonLayout, PageSaveButton } from "../Global/globalStyles.style";
import RegularDropdown from "../DropdownMenus/RegularDropdown";
import MultiSelectComponentTemplate from "../../pages/Tasks/Common/multiSelectComponent";
import DatePickerComponent from "../../pages/Tasks/Common/dateSelectComponent";
import AlertWithInput from "../AlertDialog/alertwithInput";
import ReactQuill from "react-quill";
import AlertDialog from "../AlertDialog";
import { matchPath } from "react-router-dom";
import moment from "moment";
import ReactSelectDropdownWithSearch from "../DropdownMenus/ReactSelectDropdownWithSearch";
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';

let themeSettings = getThemeSettingsVariables();
let userDetails = getLocalStorageVariables();

export default class OverallAssignment extends React.PureComponent {
    constructor(props) {
		super(props);
		this.state = {
            showLoader: false,
            componentDidMountFlag: false,
            menus: [],
            isEdit: false,
            showTemplateAlertDialog: false,
            showTemplateInfoDialog: false,
            showCreateDialog: false,
            editTemplateItem: {},
            editTemplateItem_prev: {},
            datalist: [],
            employeeMasterList: [],
            designationMasterList: [],
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount() {
		this.getInitData();
	}

    getInitData = () => {
        this.setState({
            showLoader: true,
        });
        let params = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            assignmentId: this.props.assignmentId,
        }
        if(this.props.isDraftOnward){
            params.forDraft = true;
        }
        Promise.all([
            fetch(this.props.getDatalistApi, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams(params),
            }),
        ])
        .then(([assRes]) => {
            return Promise.all([assRes.json()]);
        })
        .then(([assRes]) => {
            let datalist = [], assignmentLevelData = [];
            if(handleTokenExpiry(assRes.responseCode)) return;
            if (assRes.responseCode === Constants.CODE_SUCCESS) {
                const assignmentLevelTemplateFields = assRes.data.assignmentLevelTemplateFields;
                assignmentLevelData = assRes.data.assignmentLevelData
                if (assignmentLevelTemplateFields && isJsonString(assignmentLevelTemplateFields)) {
                    datalist = JSON.parse(assignmentLevelTemplateFields);
                    this.setFieldValues(datalist, assignmentLevelData);
                }
                this.fetchMasterFieldOptions(datalist);
            } else if (assRes.responseCode === Constants.CODE_ASSIGNMENT_ACCESS_ERROR) {
                this.setState({
                    showAlertDialogInfo: true,
                    alertDialogMessageInfo: assRes.responseMessage,
                    responseCode: assRes.responseCode
                })
            } else {
                this.setState({
                    showAlertDialogInfo: true,
                    alertDialogMessageInfo: assRes.responseMessage,
                    responseCode: assRes.responseCode
                })
            }
            
            this.setState({
                showLoader: false,
                componentDidMountFlag: true,
                datalist: datalist,
                isEdit: this.props.isEditable && assignmentLevelData.length === 0,
            });
        });
    }

    handleChangeReactQuill = (focusedIndex,value) => {
        let tempArr = [ ...this.state.datalist ];
        tempArr[focusedIndex].fieldValue = value;
        this.setState({
            datalist:tempArr
        });
    }
    modules = {
		toolbar: [
			[{ header: [1, 2, 3, false] }],
			["bold", "italic", "underline", "strike", { color: [] }, { background: [] }],
			[{ list: "ordered" }, { list: "bullet" }, { align: [] }, "link"],
			["clean"],
		],
	};

    handleQuillFocus = (focusIndex) => {
        if (this.state.isEdit) {
            let tempArr = this.state.datalist.map((item,index)=>{
                if(index === focusIndex){
                    item.isFocused = true
                }else{

                    item.isFocused = false
                }
                return item;
            })
            this.setState({
                datalist:tempArr
            })
        }
    }

    onDropDownItemClick = (item,index) => {
        let tempArr = [ ...this.state.datalist ];
        tempArr[index].fieldValue = item.value;
        this.setState({
            datalist: tempArr
        })
    }

    getDropdownSelectedDisplayValue = (item) => {
        if(isEmptyVariable(item.fieldValue)){
            return item.fieldValue;
        }
        if(item.showDescription === "Y" && !isEmptyArray(item.dropdownValues)){
            let matched = item.dropdownValues.find(dv => dv.value === item.fieldValue);
            if(matched && !isEmptyVariable(matched.description)){
                return item.fieldValue+ " " +matched.description;
            }
        }
        return item.fieldValue;
    }

    addSelectedValues = (value,index) => {
        let tempArr = [ ...this.state.datalist ];
        if (isEmptyVariable(tempArr[index].fieldValue)) {
            tempArr[index].fieldValue = [];
        }

        tempArr[index].fieldValue.push(value);
        this.setState({
            datalist:tempArr
        })
    }

    removeSelectedValues = (value,index) => {
        let tempArr = [ ...this.state.datalist ];
        let fieldValueArr = tempArr[index].fieldValue;
		let formCustomRisk = this.state.formCustomRisk;

        if(!isEmptyVariable(value)){
            let fieldValueIndex = fieldValueArr.indexOf(value);
            if(fieldValueIndex !== -1){
                fieldValueArr.splice(fieldValueIndex,1)
            }
			if(value === -1){
				formCustomRisk="";
			}
			
        }
        this.setState({
            datalist:tempArr,
			formCustomRisk:formCustomRisk
        })
    }

    handleChangeFormCustomRisk = (value) => {
        this.setState({ 
            formCustomRisk:value
        });
    }

    onCustomRiskFocus = () => {
        this.handleFocus();
        this.setState({
            formCustomRisk_isFocused:true,
        })    
    }
    
    handleFocus = () => {
        if (this.state.isEdit) {
            let tempArr = this.state.datalist.map((item)=>{
                item.isFocused = false
                return item;
            })
            this.setState({
                datalist:tempArr
            });
        }
    }

    onCustomRiskBlur = () => {
        this.setState({
            formCustomRisk_isFocused:false,
        })    
    }

    onDateChange = (dateValue,index) => {
        let tempArr = [ ...this.state.datalist ];
        tempArr[index].fieldValue = dateValue;
        this.setState({
            datalist:tempArr
        })
    };

    onAddTableClick = (index) => {
		this.setState({
			showAlertWithInputDialog: true,
			alertWithInputDialogMessage: "Enter the number of Rows and Columns",
            addToTableIndex:index,
		});
	};

    handleAlertWithInputDialogClose = () => {
		this.setState({
			showAlertWithInputDialog: false,
			alertWithInputDialogMessage: "",
		});
	};

    handleAlertDialogClose = () =>{
        this.setState({
            showAlertDialog:false,
            alertDialogMessage:""
        });
    }

    handleDeleteTable = () => {
        let tempArr = this.state.datalist;
        tempArr[this.state.deleteReactivateId].fieldValue = [];
        tempArr[this.state.deleteReactivateId].isTableAdded = false;
        this.setState({
            datalist: tempArr,
            deleteReactivateId:"",
            operationType:"",
            alertDialogHeading:"",
            proceedBtnLabel:"",
            alertDialogMessage:"",
            showAlertDialog:false,
        })
    }

    handleAddIntanceTable = (rows, cols, excelData) => {
        let tableArray = [];
        for(let i=0;i<rows;i++){
            tableArray[i]=[];
            let j= 0;
            for(j=0;j<cols;j++){
                if(!isEmptyArray(excelData)){
                    tableArray[i][j]= excelData[i][j] ?? "";
                }else{
                    tableArray[i][j] = "";
                }
            }
            tableArray[i][j] = "Action"
        }
        
        let tempArr = [ ...this.state.datalist ];
        tempArr[this.state.addToTableIndex].fieldValue = tableArray;
        tempArr[this.state.addToTableIndex].isTableAdded = true;

		this.setState({
			showAlertWithInputDialog: false,
			alertWithInputDialogMessage: "",
            tableArray:tableArray,
            datalist:tempArr,
            addToTableIndex:""
		});
	};

    addNewColumn = (index,e) => {
        let tempArr = [ ...this.state.datalist ];
        let tableArray = tempArr[index].fieldValue;
        let rowLength = tableArray.length;
        let colLength = tableArray[0].length;
        let newArr = [];

        for(let i=0;i<rowLength;i++){
            let rowArray = tableArray[i];
            rowArray.splice(colLength-1,0,"")
            newArr.push(rowArray);
        }
        tempArr[index].fieldValue = newArr;
        this.setState({
            datalist: tempArr
        })
    }

    addNewRow = (index,e) => {
        let tempArr = [ ...this.state.datalist ];
        let tableArray = tempArr[index].fieldValue;
        let singleRow = [];
        let colLength = tableArray[0].length;
        for(let i=0; i<colLength; i++){
            if(i === colLength-1){
                singleRow.push("Action")
            }else{
                singleRow.push("");
            }
        }

        tableArray.push(singleRow);
        tempArr[index].fieldValue = tableArray;

        this.setState({
            datalist: tempArr
        })
    }

    handleTableInputBlur = (rowIndex, colIndex, index, e) => {
		const value = e.currentTarget.textContent;
        let tempArr = [ ...this.state.datalist ];
        let tableArray = tempArr[index].fieldValue;
		tableArray[rowIndex][colIndex] = value;

		this.setState({
            datalist: tempArr,
        });
	};

    deleteColumn = (colIndex, index,  e) =>{
        let tempArr = [ ...this.state.datalist ];
        let tableArray = tempArr[index].fieldValue;
        let tableArrayTemp = [];

        tableArray.forEach((rowItem,rowIndex)=>{
            rowItem.splice(colIndex,1);
            tableArrayTemp[rowIndex]=[...rowItem];
        });
        tempArr[index].fieldValue = tableArrayTemp;

        this.setState({
            datalist: tempArr
        })
    }

    deleteRow = (rowIndex, index,  e) =>{
        let tempArr = [ ...this.state.datalist ];
        let tableArray = tempArr[index].fieldValue;
        tableArray.splice(rowIndex,1);
        tempArr[index].fieldValue = tableArray;

        this.setState({
            datalist: tempArr
        })
    }

    handleDeleteTableClickAlert = (fieldName,index,e) => {
        e.stopPropagation();
        this.setState({
            operationType:"Delete",
            alertDialogHeading:"Delete Field",
            proceedBtnLabel:"Delete",
            deleteReactivateId:index,
            showAlertDialog:true,
            alertDialogMessage:"Are you sure you want to delete field- "+fieldName+"?"
        })
    }

    editFields = () => {
        this.setState({
            isEdit: true,
        });
    }

    cancelEditFields = () => {
        this.setState({
            isEdit: false,
        });
    }

    saveFields = () => {
        let values = {};
        this.state.datalist.forEach(field => {
            if (field.fieldType === TemplateConstants.FIELD_TYPE_MASTER) {
                if (!isEmptyArray(field.fieldValue)) {
                    // Each selected master record travels with its own remark: [{masterValue, masterValueRemark}, ...]
                    let masterValueArr = field.fieldValue.map(masterValue => {
                        let masterValueRemark = "";
                        if (field.masterRemarksType === "Individual") {
                            masterValueRemark = field.masterRemarks?.[masterValue] ?? "";
                        } else if (field.masterRemarksType === "Single") {
                            masterValueRemark = field.masterRemarkSingle ?? "";
                        }
                        return { masterValue, masterValueRemark };
                    });
                    values[field.fieldId] = JSON.stringify(masterValueArr);
                    values[field.fieldId+"_fieldType"] = field.fieldType;
                }
                return;
            }
            let value = field.fieldValue ?? "";
            if (!isEmptyVariable(value)) {
                if (field.fieldType === TemplateConstants.FIELD_TYPE_TEXT) {
                    value = (value);
                }
                else if (field.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI || field.fieldType === TemplateConstants.FIELD_TYPE_TABLE) {
                    value = JSON.stringify(value);
                }
                values[field.fieldId] = value;
                values[field.fieldId+"_fieldType"] = field.fieldType;
            }
        });
        this.setState({
            showLoader: true,
        });

        fetch(this.props.saveDatalistApi, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                assignmentId: this.props.assignmentId,
                ...values,
            }),
        })
        .then(assRes => assRes.json())
        .then(assRes => {
            if(handleTokenExpiry(assRes.responseCode)) return;
            if (assRes.responseCode === Constants.CODE_SUCCESS) {
                fetch(this.props.getDatalistApi, {
                    method: "POST",
                    mode: "cors",
                    body: new URLSearchParams({
                        email: userDetails.email,
                        accessToken: userDetails.accessToken,
                        assignmentId: this.props.assignmentId,
                    }),
                })
                .then(assRes => assRes.json())
                .then(assRes => {
                    let datalist = [];
                    if(handleTokenExpiry(assRes.responseCode)) return;
                    if (assRes.responseCode === Constants.CODE_SUCCESS) {
                        const assignmentLevelTemplateFields = assRes.data.assignmentLevelTemplateFields, assignmentLevelData = assRes.data.assignmentLevelData;
                        if (assignmentLevelTemplateFields && isJsonString(assignmentLevelTemplateFields)) {
                            datalist = JSON.parse(assignmentLevelTemplateFields);
                            this.setFieldValues(datalist, assignmentLevelData);
                        }
                    }
        
                    this.setState({
                        showLoader: false,
                        datalist: datalist,
                        isEdit: false,
                    });
                });
            }
        });
    }

    setFieldValues = (datalist, assignmentLevelData) => {
        datalist = datalist.map(field => {
            const fieldData = assignmentLevelData.find(data => data.fieldId.toString() === field.fieldId.toString());
            if (fieldData) {
                let value = fieldData.value;
                if (field.fieldType === TemplateConstants.FIELD_TYPE_MASTER) {
                    // Each selected master record travels with its own remark: [{masterValue, masterValueRemark, ...display fields}]
                    let masterValueArr = isJsonString(value) ? JSON.parse(value) : value;
                    if (!isEmptyArray(masterValueArr)) {
                        field.fieldValue = [];
                        masterValueArr.forEach((record,idx) => {
                            let id = isEmptyVariable(record.masterValue) ? idx : record.masterValue;
                            field.fieldValue.push(id);
                            let displayRecord = field.masterType === TemplateConstants.MASTER_TYPE_EMPLOYEE ? {
                                salutation: record.salutation,
                                firstName: record.firstName,
                                lastName: record.lastName,
                                designation: record.designation,
                            } : {
                                name: record.masterName,
                                shortName: record.masterShortName,
                                description: record.masterDesc,
                            };
                            if(Object.values(displayRecord).some(v => !isEmptyVariable(v))){
                                if(isEmptyVariable(field.masterValueDisplayMap)) field.masterValueDisplayMap = {};
                                field.masterValueDisplayMap[id] = displayRecord;
                            }
                            let remark = record.masterValueRemark ?? "";
                            if (field.masterRemarksType === "Individual") {
                                if (isEmptyVariable(field.masterRemarks)) field.masterRemarks = {};
                                field.masterRemarks[id] = remark;
                            } else if (field.masterRemarksType === "Single" && idx === 0) {
                                field.masterRemarkSingle = remark;
                            }
                        });
                    } else {
                        field.fieldValue = [];
                    }
                } else if ((field.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI || field.fieldType === TemplateConstants.FIELD_TYPE_TABLE) && isJsonString(value)) {
                    value = JSON.parse(value);
                    field.isTableAdded = true;
                    field.fieldValue = value;
                } else {
                    field.fieldValue = value;
                }
            }
            return field;
        });
    }

    fetchMasterFieldOptions = (datalist) => {
        let masterTypesUsed = new Set((datalist || [])
            .filter(item => item.fieldType === TemplateConstants.FIELD_TYPE_MASTER)
            .map(item => item.masterType));

        if(masterTypesUsed.has("Designation")){
            fetch(Constants.GetMasterFieldDesignations, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                }),
            })
            .then(response => response.json())
            .then(data => {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        designationMasterList: data.data.designationList,
                    });
                }
            });
        }

        if(masterTypesUsed.has("Employee")){
            fetch(Constants.GetAssignmentsDetails, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                    assignmentId: this.props.assignmentId,
                }),
            })
            .then(response => response.json())
            .then(assignmentRes => {
                if(handleTokenExpiry(assignmentRes.responseCode)) return;
                let unitIds = [];
                if(assignmentRes.responseCode === Constants.CODE_SUCCESS){
                    let assignmentDetails = assignmentRes.data.assignmentDetails;
                    if(!isEmptyVariable(assignmentDetails?.unitList)){
                        unitIds.push(parseInt(assignmentDetails.unitList.split(":-:")[1]));
                    }
                }
                let empParams = {
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                    assignmentId: this.props.assignmentId,
                    unitIds: JSON.stringify(unitIds),
                    resultsize: 10000,
                    search: ""
                }
                if(this.props.isOngoingOnward){
                    empParams.forOngoing = true;
                }
                if(this.props.isDraftOnward){
                    empParams.forDraft = true;
                }
                fetch(Constants.GetAllEmployees, {
                    method: "POST",
                    mode: "cors",
                    body: new URLSearchParams(empParams),
                })
                .then(response => response.json())
                .then(data => {
                    if(handleTokenExpiry(data.responseCode)) return;
                    else if(data.responseCode === Constants.CODE_SUCCESS){
                        let employeeList = (data.data.result || []).map(emp => ({
                            ...emp,
                            id: emp.employeeId,
                            name: `${isEmptyVariable(emp.salutation)?"":emp.salutation+" "}${emp.firstName}${isEmptyVariable(emp.lastName)?"":" "+emp.lastName}`,
                        }));
                        this.setState({
                            employeeMasterList: employeeList,
                        });
                    }
                });
            });
        }
    }

    onMasterSelectValue = (selectedItem,index) => {
        let tempArr = [ ...this.state.datalist ];
        tempArr[index].fieldValue = isEmptyVariable(selectedItem?.id)?[]:[selectedItem.id];
        this.setState({
            datalist:tempArr
        })
    }

    onMasterMultiSelectAdd = (index,args) => {
        this.addSelectedValues(args.itemData.id,index);
    }

    onMasterMultiSelectRemove = (index,args) => {
        this.removeSelectedValues(args.itemData.id,index);
    }

    handleMasterRemarkChange = (index,itemId,value) => {
        let tempArr = [ ...this.state.datalist ];
        if(isEmptyVariable(tempArr[index].masterRemarks)){
            tempArr[index].masterRemarks = {};
        }
        tempArr[index].masterRemarks[itemId] = value;
        this.setState({
            datalist:tempArr
        })
    }

    handleMasterRemarkSingleChange = (index,value) => {
        let tempArr = [ ...this.state.datalist ];
        tempArr[index].masterRemarkSingle = value;
        this.setState({
            datalist:tempArr
        })
    }

    getMasterDisplayParts = (item,record) => {
        if(isEmptyVariable(record)) return [];
        let parts = [];
        if(item.masterType === TemplateConstants.MASTER_TYPE_EMPLOYEE){
            if(item.masterShowEmployeeTitle === "Y" && !isEmptyVariable(record.salutation)){
                parts.push({ text: record.salutation, format: item.masterReportTitleFormat, separatorBefore: " " });
            }
            let fullName = [record.firstName,record.lastName].filter(v => !isEmptyVariable(v)).join(" ");
            if(item.masterShowEmployeeName === "Y" && !isEmptyVariable(fullName)){
                parts.push({ text: fullName, format: item.masterReportEmployeeNameFormat, separatorBefore: " " });
            }
            if(item.masterShowEmployeeDesignation === "Y" && !isEmptyVariable(record.designation)){
                let designationPart = this.getDesignationDisplayPart(item,record.designation);
                parts.push({ text: designationPart.text, format: item.masterReportDesignationFormat, separatorBefore: designationPart.separatorBefore });
            }
            return parts;
        }
        if(!isEmptyVariable(item.masterNameOrder)){
            parts.push({ order: parseInt(item.masterNameOrder), text: record.name, format: item.masterReportNameFormat });
        }
        if(!isEmptyVariable(item.masterShortNameOrder)){
            parts.push({ order: parseInt(item.masterShortNameOrder), text: record.shortName, format: item.masterReportShortNameFormat });
        }
        if(!isEmptyVariable(item.masterDescriptionOrder)){
            parts.push({ order: parseInt(item.masterDescriptionOrder), text: record.description, format: item.masterReportDescriptionFormat });
        }
        return parts.filter(part => !isEmptyVariable(part.text)).sort((a,b) => a.order-b.order);
    }

    getMasterDisplaySeparator = (item) => {
        return item.masterShowDisplaySeparator === "Y" ? item.masterDisplaySeparator : " ";
    }

    getDesignationDisplayPart = (item,designationText) => {
        const openToClose = {"(":")", "[":"]", "{":"}"};
        const closeToOpen = {")":"(", "]":"[", "}":"{"};
        let separatorVal = item.masterShowDisplaySeparator === "Y" ? item.masterDisplaySeparator : "";
        let openChar = [...separatorVal].find(c => openToClose[c]);
        let closeChar = [...separatorVal].find(c => closeToOpen[c]);
        let wrap;
        if(openChar){
            wrap = [openChar, openToClose[openChar]];
        }else if(closeChar){
            wrap = [closeToOpen[closeChar], closeChar];
        }
        if(wrap){
            return { text: wrap[0]+designationText+wrap[1], separatorBefore: " " };
        }
        return { text: designationText, separatorBefore: " "+this.getMasterDisplaySeparator(item)+" " };
    }

    getMasterRecordForId = (item,id) => {
        if(!isEmptyVariable(item.masterValueDisplayMap?.[id])){
            return item.masterValueDisplayMap[id];
        }
        let masterList = item.masterType === TemplateConstants.MASTER_TYPE_EMPLOYEE ? this.state.employeeMasterList : this.state.designationMasterList;
        return masterList.find(d => d.id === id);
    }

    getMasterMultiSelectDataSource = (item) => {
        let baseList = item.masterType === TemplateConstants.MASTER_TYPE_EMPLOYEE ? this.state.employeeMasterList : this.state.designationMasterList;
        if(isEmptyVariable(item.masterValueDisplayMap) || isEmptyArray(item.fieldValue)){
            return baseList;
        }
        let existingIds = new Set(baseList.map(d => d.id));
        let extraEntries = item.fieldValue
            .filter(id => !existingIds.has(id) && !isEmptyVariable(item.masterValueDisplayMap[id]))
            .map(id => {
                let record = item.masterValueDisplayMap[id];
                let name = item.masterType === TemplateConstants.MASTER_TYPE_EMPLOYEE
                    ? [record.salutation,record.firstName,record.lastName].filter(v => !isEmptyVariable(v)).join(" ")
                    : record.name;
                return { ...record, id, name };
            });
        return isEmptyArray(extraEntries) ? baseList : [...baseList, ...extraEntries];
    }

    renderMasterDisplayLabel = (item,record) => {
        let parts = this.getMasterDisplayParts(item,record);
        if(isEmptyArray(parts)){
            return <span>{record?.name ?? [record?.firstName,record?.lastName].filter(v => !isEmptyVariable(v)).join(" ")}</span>;
        }
        let separator = this.getMasterDisplaySeparator(item);
        return (
            <span>
                {parts.map((part,partIdx) => (
                    <React.Fragment key={partIdx}>
                        {partIdx > 0 && (part.separatorBefore ?? separator)}
                        <span style={{
                            fontWeight: part.format?.bold?"bold":"normal",
                            fontStyle: part.format?.italic?"italic":"normal",
                            textDecoration: part.format?.underline?"underline":"none",
                        }}>
                            {part.text}
                        </span>
                    </React.Fragment>
                ))}
            </span>
        );
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
        if(this.state.responseCode === Constants.CODE_ASSIGNMENT_ACCESS_ERROR ||
            this.state.responseCode === Constants.CODE_ASSIGNMENT_SPECIFIC_ACCESS_ERROR){
            if(matchPath(this.props.history.location.pathname, { path: ["/ongoinggeneral" ]})){
				this.props.history.push(Constants.URL_ONGOING_REPORTS);
			}else if(matchPath(this.props.history.location.pathname, { path: ["/draftgeneral" ]})){
				this.props.history.push(Constants.URL_DRAFT_REPORTS);
			}else{
				this.props.history.push(Constants.URL_COMPLETED_REPORTS);
			}
		}
    }

    render () {
        return (
            <div>
                {
                    this.state.showLoader &&
                    <div class="loader"></div>
                }
                {this.state.componentDidMountFlag &&
                    <div className="m-t-10">
                        <div className="row custom-row">
                            <div className="col-md-8 custom-col add-template">
                                {
                                    this.state.datalist.map((item,index)=>{
                                        let showHeader = true;
                                        if(item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI){
                                            if(item.isFromRiskMaster){
                                                if(item.isRiskMasterEnabled === "Y"){
                                                    showHeader = true;
                                                }else{
                                                    showHeader = false;
                                                }
                                            }else{
                                                showHeader = true;
                                            }
                                        }
                                        return (
                                            <div class="editor-card">
                                                {
                                                    showHeader &&
                                                    <div className={(item.isNRChecked === "Y" || !this.state.isEdit)?"task-header-layout editor-border-bottom":"task-header-layout"}>
                                                        <h6 className="editor-heading">{item.fieldName}{item.isMandatorySelected === "Y"?"*":""}</h6>
                                                    </div>
                                                }
                                                {
                                                    item.fieldType === TemplateConstants.FIELD_TYPE_TEXT &&
                                                    <div className="row custom-row">
                                                        <div className="col-md-12 custom-col">
                                                            {(item.isNRChecked === "Y" || !this.state.isEdit) ?
                                                                <div class="editor-text-layout">
                                                                    <div dangerouslySetInnerHTML={{__html: item.fieldValue}} />
                                                                </div>
                                                                :
                                                                <div className={item.isNRChecked === "Y"?"editor-layout editor-disabled":"editor-layout"}>
                                                                    <ReactQuill
                                                                        placeholder={item.placeholderValue}
                                                                        value={!isEmptyVariable(item.fieldValue)?item.fieldValue:""} 
                                                                        id = {item.fieldName+":-:"+index}
                                                                        onChange={this.handleChangeReactQuill.bind(this,index)}
                                                                        className={item.isFocused?
                                                                            (item.isNRChecked === "Y"?"two-lines":"two-lines-focus"):"two-lines"}
                                                                        modules={this.modules}
                                                                        onFocus={this.handleQuillFocus.bind(this,index)}
                                                                        readOnly={(item.isNRChecked === "Y" || !this.state.isEdit) ? true : false}
                                                                    />
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN &&
                                                <div className="row custom-row">
                                                    <div className="col-md-12 custom-col">
                                                        {(item.isNRChecked === "Y" || !this.state.isEdit) ?
                                                            <div class="editor-text-layout">
                                                                <p>{this.getDropdownSelectedDisplayValue(item)}</p>
                                                            </div>
                                                            :
                                                            <div className={item.isNRChecked === "Y"?"editor-layout editor-disabled":"editor-layout"}>
                                                                <RegularDropdown
                                                                    placeholder={isEmptyVariable(item.fieldValue)?item.placeholderValue:this.getDropdownSelectedDisplayValue(item)}
                                                                    dropdownArr={item.dropdownValues}
                                                                    labelParam="value"
                                                                    secondLabelParam={item.showDescription === "Y" ? "description" : ""}
                                                                    onDropDownItemClick={this.onDropDownItemClick}
                                                                    disabled={item.isNRChecked === "Y" || !this.state.isEdit ?true:false}
                                                                    defaultPlaceholderDropDown={item.placeholderValue}
                                                                    udf = {index}
                                                                />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                }
                                                {
                                                    item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
                                                    item.isRiskMasterEnabled === "Y" &&
                                                    item.isFromRiskMaster &&
                                                    <div className="row custom-row">
                                                        <div className="col-md-12 custom-col">
                                                            {!this.props.isEdit ?
                                                                <ul style={{marginBottom:5,paddingLeft:25}}>
                                                                    {
                                                                        item.fieldValue.map(valueItem=>{

                                                                            return(
                                                                                <li className="m-b-0 font-size-p">{valueItem}</li>
                                                                            )
                                                                        })  
                                                                    }
                                                                </ul>
                                                            :
                                                            <div className={item.isNRChecked === "Y"?"editor-layout editor-disabled":"editor-layout"}>
                                                                {/* {!this.state.isEdit
                                                                    ? <RegularDropdown 
                                                                        placeholder={!isEmptyArray(item.fieldValue) ? item.fieldValue.join(", ") : item.placeholderValue}
                                                                        dropdownArr={[]}
                                                                        disabled={true}
                                                                    />
                                                                    :  */}
                                                                        <MultiSelectComponentTemplate
                                                                            templateItemIndex={index}
                                                                            allowFiltering={true}
                                                                            fields = {{text:"displayName",value:"businessRiskId"}}
                                                                            dropdownValues={this.state.businessRisk}
                                                                            placeholderValue={item.placeholderValue} 
                                                                            addSelectedValues={this.addSelectedValues}
                                                                            removeSelectedValues={this.removeSelectedValues}
                                                                            fieldValue={!isEmptyArray(item.fieldValue)?item.fieldValue:""}
                                                                            isFromRiskMaster={item.isFromRiskMaster}
                                                                            handleFocus = {this.handleFocus}
                                                                            disabled={!this.state.isEdit}
                                                                        />
                                                                {/* } */}
                                                                {
                                                                    item.fieldValue.some(fieldItem => fieldItem === -1)  &&
                                                                    <div class="editor-layout" style={{marginTop:15}}>
                                                                        <ReactQuill
                                                                            placeholder={item.placeholderValue}
                                                                            value={this.state.formCustomRisk} 
                                                                            onChange={this.handleChangeFormCustomRisk}
                                                                            className={this.state.formCustomRisk_isFocused?
                                                                                (item.isNRChecked === "Y"?"two-lines":"two-lines-focus"):"two-lines"}
                                                                            modules={this.modules}
                                                                            onFocus={this.onCustomRiskFocus}
                                                                            onBlur={this.onCustomRiskBlur}
                                                                            readOnly={item.isNRChecked === "Y" || !this.state.isEdit ? true : false}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
                                                    !item.isFromRiskMaster &&
                                                    <div className="row custom-row">
                                                        <div className="col-md-12 custom-col">
                                                            {!this.state.isEdit ? 
                                                                <div class={item.isNRChecked === "Y"?"editor-disabled":""}>
                                                                    <ul style={{marginBottom:5,paddingLeft:25}}>
                                                                        {
                                                                            item.fieldValue.map(valueItem=>{

                                                                                return(
                                                                                    <li className="m-b-0 font-size-p">{valueItem}</li>
                                                                                )
                                                                            })  
                                                                        }
                                                                    </ul>
                                                                </div>
                                                            :
                                                            <div className={item.isNRChecked === "Y"?"editor-layout editor-disabled":"editor-layout"}>
                                                                {/* {!this.state.isEdit
                                                                    ? <RegularDropdown 
                                                                        placeholder={!isEmptyArray(item.fieldValue) ? item.fieldValue.join(", ") : item.placeholderValue}
                                                                        dropdownArr={[]}
                                                                        disabled={true}
                                                                    /> */}
                                                                    : <MultiSelectComponentTemplate
                                                                        templateItemIndex={index}
                                                                        allowFiltering={true}
                                                                        fields = {{text:"value",value:"value"}}
                                                                        dropdownValues={item.dropdownValues}
                                                                        placeholderValue={item.placeholderValue} 
                                                                        addSelectedValues={this.addSelectedValues}
                                                                        removeSelectedValues={this.removeSelectedValues}
                                                                        fieldValue={!isEmptyArray(item.fieldValue)?item.fieldValue:""}
                                                                        handleFocus = {this.handleFocus}
                                                                    />
                                                                {/* } */}
                                                            </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    item.fieldType === TemplateConstants.FIELD_TYPE_MASTER &&
                                                    <div className="row custom-row">
                                                        <div className="col-md-12 custom-col">
                                                            {(item.isNRChecked === "Y" || !this.state.isEdit) ?
                                                                <div class="editor-text-layout">
                                                                    {
                                                                        isEmptyArray(item.fieldValue)
                                                                        ?
                                                                        <p className="m-b-0">-</p>
                                                                        :
                                                                        <ul style={{marginBottom:5,paddingLeft:25}}>
                                                                            {
                                                                                item.fieldValue.map((selectedId) => {
                                                                                    let record = this.getMasterRecordForId(item,selectedId);
                                                                                    let remark = item.masterRemarksType === "Individual"
                                                                                        ? item.masterRemarks?.[selectedId]
                                                                                        : item.masterRemarkSingle;
                                                                                    return (
                                                                                        <li className="m-b-0 font-size-p">
                                                                                            {this.renderMasterDisplayLabel(item,record)}
                                                                                            {!isEmptyVariable(remark) && <span>{" - "+remark}</span>}
                                                                                        </li>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </ul>
                                                                    }
                                                                </div>
                                                                :
                                                                <div className="editor-layout">
                                                                    {
                                                                        item.fieldType === TemplateConstants.FIELD_TYPE_MASTER &&
                                                                        (item.masterType === "Designation" || item.masterType === "Employee") &&
                                                                        item.masterSelectionType === "Multi-Select" &&
                                                                        <MultiSelectComponent
                                                                            key={"masterMultiSelect:-:"+index+":-:"+(item.masterType === "Designation"?this.state.designationMasterList:this.state.employeeMasterList).length}
                                                                            dataSource={this.getMasterMultiSelectDataSource(item)}
                                                                            fields={{text:"name",value:"id"}}
                                                                            itemTemplate={(data) => this.renderMasterDisplayLabel(item,this.getMasterRecordForId(item,data.id) ?? data)}
                                                                            valueTemplate={(data) => this.renderMasterDisplayLabel(item,this.getMasterRecordForId(item,data.id) ?? data)}
                                                                            placeholder={item.placeholderValue}
                                                                            mode="CheckBox"
                                                                            closePopupOnSelect={false}
                                                                            allowFiltering={true}
                                                                            select={this.onMasterMultiSelectAdd.bind(this,index)}
                                                                            removed={this.onMasterMultiSelectRemove.bind(this,index)}
                                                                            cssClass="clientsChecklist dialogcl"
                                                                            value={!isEmptyArray(item.fieldValue)?item.fieldValue:""}
                                                                            showDropDownIcon={true}
                                                                            showClearButton={true}
                                                                            open={this.handleFocus}
                                                                        >
                                                                            <Inject services={[CheckBoxSelection]} />
                                                                        </MultiSelectComponent>
                                                                    }
                                                                    {
                                                                        item.fieldType === TemplateConstants.FIELD_TYPE_MASTER &&
                                                                        (item.masterType === "Designation" || item.masterType === "Employee") &&
                                                                        item.masterSelectionType === "Single-Select" &&
                                                                        <ReactSelectDropdownWithSearch
                                                                            selectedDDObj={this.getMasterRecordForId(item,item.fieldValue?.[0])}
                                                                            handleReactSelectClose={(selectedItem) => this.onMasterSelectValue(selectedItem,index)}
                                                                            selectDropdownArr={item.masterType === "Designation"?this.state.designationMasterList:this.state.employeeMasterList}
                                                                            label={"name"}
                                                                            value={"id"}
                                                                            formatOptionLabel={(record) => this.renderMasterDisplayLabel(item,record)}
                                                                            placeholder={item.placeholderValue}
                                                                            isClearSelect={true}
                                                                        />
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                        {
                                                            this.state.isEdit && item.isNRChecked !== "Y" &&
                                                            item.masterRemarksType === "Individual" &&
                                                            !isEmptyArray(item.fieldValue) &&
                                                            <div className="col-md-12 custom-col">
                                                                <div className="common-tab-bg" style={{marginTop:10}}>
                                                                    <div className="common-table" style={{width:"100%"}}>
                                                                        <table className="table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th width={"40%"}>Name</th>
                                                                                    <th width={"60%"}>Remarks</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {item.fieldValue.map((selectedId) => {
                                                                                    let selectedItem = this.getMasterRecordForId(item,selectedId);
                                                                                    return (
                                                                                        <tr>
                                                                                            <td>{this.renderMasterDisplayLabel(item,selectedItem)}</td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    value={item.masterRemarks?.[selectedId] || ""}
                                                                                                    onChange={(e) => this.handleMasterRemarkChange(index,selectedId,e.target.value)}
                                                                                                    className="form-control mt-1 mb-1"
                                                                                                    style={{height:34, fontSize:"11.7px"}}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                    );
                                                                                })}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            this.state.isEdit && item.isNRChecked !== "Y" &&
                                                            item.masterRemarksType === "Single" &&
                                                            <div className="col-md-12 custom-col" style={{marginTop:10}}>
                                                                <p className='m-b-0' style={{fontWeight:"bold", fontSize:12}}>Remark</p>
                                                                <div className="editor-layout">
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Enter Remarks"
                                                                        value={item.masterRemarkSingle || ""}
                                                                        onChange={(e) => this.handleMasterRemarkSingleChange(index,e.target.value)}
                                                                        className="form-control"
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    item.fieldType === TemplateConstants.FIELD_TYPE_DATE &&
                                                    <div className="row custom-row">
                                                        <div className="col-md-12 custom-col">
                                                            {this.state.isEdit ? 
                                                            <div className={item.isNRChecked === "Y"?"editor-layout editor-disabled":"editor-layout"}>
                                                                <DatePickerComponent
                                                                    templateItemIndex={index}
                                                                    onDateChange={this.onDateChange}
                                                                    format={"DD/MM/YYYY"}
                                                                    placeholderValue={item.placeholderValue}
                                                                    isNRChecked={item.isNRChecked}
                                                                    fieldValue={!isEmptyVariable(item.fieldValue)?item.fieldValue:""}
                                                                    isDisabled={this.state.isEdit ? "N" : "Y"}
                                                                />
                                                            </div> 
                                                            :
                                                            <div class="editor-text-layout">
                                                                {
                                                                    isEmptyVariable((item.fieldValue))
                                                                    ?
                                                                    <p>{"-"}</p>
                                                                    :
                                                                    <p>{moment(item.fieldValue).format("DD/MM/YYYY")}</p>
                                                                }
                                                                
                                                            </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    item.fieldType === TemplateConstants.FIELD_TYPE_TABLE &&
                                                    <div className="flex-center-layout" style={{justifyContent:"center"}}>
                                                        {
                                                            !item.isTableAdded && this.state.isEdit &&
                                                            <AddNewButtonLayout themeSettings={themeSettings}>
                                                                <a onClick={this.onAddTableClick.bind(this,index)} href="javascript:void(0);"
                                                                    disabled={
                                                                        item.isNRChecked === "Y"
                                                                            ? true
                                                                            : false
                                                                    }
                                                                >
                                                                    <span className="material-icons">add_circle</span>
                                                                    <p>Add Table</p>
                                                                </a>
                                                            </AddNewButtonLayout>
                                                        }
                                                        {
                                                            item.isTableAdded &&
                                                            // !isEmptyArray(this.state.columnArray) && !isEmptyArray(this.state.rowArray) && 
                                                            <div
                                                                style={{ width: "100%", marginTop: 10, boxShadow: "none" }}
                                                                class={
                                                                    item.isNRChecked === "Y"
                                                                        ? "editor-layout editor-disabled common-table"
                                                                        : "common-table editor-layout"
                                                                }
                                                            >
                                                                {this.state.isEdit &&
                                                                    <div className="flex-center-layout m-b-10" style={{justifyContent:"right"}}>
                                                                        <button className="flex-center-layout instances-new-row" onClick={this.addNewColumn.bind(this,index)}>
                                                                            <span className="material-icons">add</span>
                                                                            <p>Add New Column</p>
                                                                        </button>
                                                                        <button className="flex-center-layout instances-new-row" onClick={this.addNewRow.bind(this,index)}>
                                                                            <span className="material-icons">add</span>
                                                                            <p>Add New Row</p>
                                                                        </button>
                                                                    </div>
                                                                }
                                                                <table class="table instances-table">
                                                                    {
                                                                        item.fieldValue.map((rowItem, rowIndex) =>  {
                                                                            if(rowIndex === 0){
                                                                                return <thead className="instances-thead">
                                                                                    <tr>
                                                                                    {
                                                                                        rowItem.map((colItem, colIndex) => {
                                                                                            if(colItem === "Action") return;
                                                                                            return <th width={colItem === "Action"?"5%":""} className= {colItem === "Action"?"text-center":""}>
                                                                                                <div className="instances-table-header">
                                                                                                    <p
                                                                                                        contenteditable={colItem === "Action" ? "false" : (this.state.isEdit ? "true" : "false")}
                                                                                                        onBlur={this.handleTableInputBlur.bind(this, rowIndex, colIndex,index)}
                                                                                                    >
                                                                                                        {colItem}
                                                                                                    </p>
                                                                                                    {colItem === "Action" ? null : (
                                                                                                        this.state.isEdit &&
                                                                                                        <div className="instances-table-del-column">
                                                                                                            <span
                                                                                                                onClick={this.deleteColumn.bind(this, colIndex,index)}
                                                                                                                className="material-icons"
                                                                                                                style = {{cursor:'pointer'}}
                                                                                                            >
                                                                                                                delete
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </th>
                                                                                            
                                                                                        })
                                                                                    }
                                                                                    </tr>
                                                                                </thead>
                                                                                    
                                                                            }else{
                                                                                return <tbody className="instances-thead">
                                                                                    <tr>
                                                                                    {
                                                                                        rowItem.map((colItem, colIndex) => {
                                                                                            if(colItem === "Action") return;
                                                                                            return <td
                                                                                                className={colItem === "Action" ? "text-center" : ""}
                                                                                                contenteditable={colItem === "Action" ? "false" : (this.state.isEdit ? "true" : "false")}
                                                                                                onBlur={this.handleTableInputBlur.bind(this, rowIndex, colIndex,index)}
                                                                                            >
                                                                                                {
                                                                                                    colItem === "Action" ? (
                                                                                                        this.state.isEdit && 
                                                                                                        <div className="instances-table-del-cell">
                                                                                                            <span
                                                                                                                onClick={this.deleteRow.bind(this,rowIndex,index)}
                                                                                                                className="material-icons"
                                                                                                                style = {{cursor:'pointer'}}
                                                                                                            >
                                                                                                                delete
                                                                                                            </span>
                                                                                                        </div>
                                                                                                ) : (
                                                                                                    colItem
                                                                                                )}
                                                                                            </td>
                                                                                        })
                                                                                    }
                                                                                    </tr>
                                                                                </tbody>
                                                                            }

                                                                        })
                                                                    }
                                                                    
                                                                </table>
                                                                {this.state.isEdit &&
                                                                    <div className="addnew-row-wrapper">
                                                                        <button className="flex-center-layout instances-new-row" onClick={this.handleDeleteTableClickAlert.bind(this,item.fieldName,index)}>
                                                                            <span className="material-icons">delete</span>
                                                                            <p>Delete Table</p>
                                                                        </button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    !isEmptyVariable(item.valueErr) &&
                                                    <span className="cm-error">{item.valueErr}</span>
                                                }
                                            </div>
                                        )
                                    })
                                }
                                {
                                    this.props.isEditable && (
                                        this.state.isEdit 
                                        ? <div className="common-close-save m-b-20">
                                            <div className="common-close-save-col">
                                                <button onClick={this.cancelEditFields} type="button" className="common-close">Cancel</button>
                                                <PageSaveButton
                                                    themeSettings={themeSettings}
                                                    onClick={this.saveFields}
                                                    type="button"
                                                >
                                                    Save
                                                </PageSaveButton>
                                            </div>
                                        </div>
                                        : <div className="text-center">
                                            <PageSaveButton
                                                themeSettings={themeSettings}
                                                onClick={this.editFields}
                                                type="button"
                                            >
                                                Edit
                                            </PageSaveButton>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                }
                <AlertWithInput
                    showAlertDialog={this.state.showAlertWithInputDialog}
                    handleAlertDialogClose={this.handleAlertWithInputDialogClose}
                    alertDialogHeading={"Instances"}
                    alertDialogMessage={this.state.alertWithInputDialogMessage}
                    proceedBtnClick={this.handleAddIntanceTable}
                    proceedBtnLabel={"Create"}
                    themeSettings={themeSettings}
                />
                <AlertDialog 
                    showAlertDialog={this.state.showAlertDialog}
                    handleAlertDialogClose={this.handleAlertDialogClose}
                    type={
                        (this.state.operationType === "Delete")
                        ?
                        Constants.ALERT_TYPE_WARNING
                        :
                        Constants.ALERT_TYPE_INFO
                    }
                    alertDialogMessage={this.state.alertDialogMessage}
                    proceedBtnClick={
                        (this.state.operationType === "Delete")
                        ?
                        this.handleDeleteTable
                        :
                        ""
                    }
                    proceedBtnLabel={this.state.proceedBtnLabel }
                    themeSettings={themeSettings}
                />
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={themeSettings}
                />
            </div>
        )
    }
}
